export default "__VITE_ASSET__wJixqTnR__"